import DeliveryNote2 from "assets/print-templates/delivery-note-2.jpg";
import { numberFormatAsString } from "commons/ultilities";
import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useMemo } from "react";
import { ElementToPrint } from "share-components/templates/print/element";

import { PreviewPrinting } from "share-components/templates/print/print-preview";
import {
  RowElement,
  RowItemElement,
  RowsElementProps,
} from "share-components/templates/print/rows-element";
export const DeliveryNotePrint2Preview = observer(() => {
  const {
    deliveryNoteManagement: { openPrint2Preview, setProp, deliveryNoteDetail },
  } = useStores();
  const onCloseHandler = useCallback(() => {
    setProp("openPrint2Preview", false);
  }, [setProp]);
  const fontSize = "12px";
  const fontSize2 = "14px";
  const dateElements = useMemo(() => {
    const dateTime: ElementToPrint[] = [
      {
        name: "date",
        left: "16cm",
        top: "1.8cm",
        value: dateTimeDisplay(deliveryNoteDetail?.date || ""),
        fontSize: fontSize,
        width: "4cm",
      },
      {
        name: "receiptNumber",
        left: "16cm",
        top: "2.4cm",
        value: deliveryNoteDetail?.number || "",
        fontSize: fontSize,
        width: "4cm",
      },
    ];
    return dateTime;
  }, [deliveryNoteDetail?.date, deliveryNoteDetail?.number]);

  const deliveryNoteElements = useMemo(() => {
    const deliveryNoteElms: ElementToPrint[] = [
      {
        name: "customerName",
        value: deliveryNoteDetail?.customer?.name || "",
        left: "4cm",
        top: "3.3cm",
        width: "9.5cm",
        fontSize: fontSize2,
      },
      {
        name: "deliveryAddress",
        value: deliveryNoteDetail?.deliveryAddress?.address || "",
        left: "4cm",
        top: "4.1cm",
        width: "9.5cm",
        fontSize: fontSize2,
      },
      {
        name: "orderNumber",
        value: deliveryNoteDetail?.purchaseOrder?.poNumber || "",
        left: "16.7cm",
        top: "3.3cm",
        width: "3.8cm",
        fontSize: fontSize2,
      },
      {
        name: "orderDate",
        value: dateTimeDisplay(deliveryNoteDetail?.purchaseOrder?.poDate),
        left: "16.7cm",
        top: "4.1cm",
        width: "3.8cm",
        fontSize: fontSize2,
      },
      {
        name: "note",
        value: deliveryNoteDetail?.note || "",
        left: "2.3cm",
        top: "9.9cm",
        width: "17.8cm",
        fontSize: fontSize2,
      },
      {
        name: "man",
        value: deliveryNoteDetail?.man || "",
        left: "5.5cm",
        top: "12.5cm",
        width: "3cm",
        fontSize: fontSize2,
        textAlight: "center",
      },
    ];
    return deliveryNoteElms;
  }, [
    deliveryNoteDetail?.customer?.name,
    deliveryNoteDetail?.deliveryAddress?.address,
    deliveryNoteDetail?.man,
    deliveryNoteDetail?.note,
    deliveryNoteDetail?.purchaseOrder?.poDate,
    deliveryNoteDetail?.purchaseOrder?.poNumber,
  ]);

  const deliveryNoteItemElements = useMemo((): RowsElementProps | undefined => {
    if (!deliveryNoteDetail || !deliveryNoteDetail?.items) {
      return undefined;
    }
    const rowElementProps: RowsElementProps = {
      top: "5.9cm",
      left: "0.4cm",
      rows: [],
      fontSizeDefault: fontSize,
      width: "19.5cm",
      elementSpacing: "4.1px",
      lineHeight: "23px",
      height: "3.1cm",
    };

    deliveryNoteDetail.items.forEach((x, idx) => {
      const rowElement: RowElement = {
        elements: [],
      };
      const ordinalNumberElm: RowItemElement = {
        value: (idx + 1).toString(),
        name: "ordinalNumber",
        width: "0.7cm",
        textAlign: "start",
      };
      rowElement.elements.push(ordinalNumberElm);
      const productCodeElm: RowItemElement = {
        value: x.product?.code || "",
        name: "productCode",
        width: "2.9cm",
      };
      rowElement.elements.push(productCodeElm);
      const productNameElm: RowItemElement = {
        value: x.product?.name || "",
        name: "productName",
        width: "6.7cm",
      };
      rowElement.elements.push(productNameElm);

      const unitElm: RowItemElement = {
        value: x.product?.unitOfCalculation || "",
        name: "unit",
        width: "1cm",
        textAlign: "flex-end",
      };
      rowElement.elements.push(unitElm);

      const amountElm: RowItemElement = {
        value: numberFormatAsString(x.amount?.toString() || ""),
        name: "amount",
        width: "1.5cm",
        textAlign: "flex-end",
      };
      rowElement.elements.push(amountElm);

      const packageElm: RowItemElement = {
        value: numberFormatAsString(x.package?.toString() || ""),
        name: "package",
        width: "0.8cm",
        textAlign: "flex-end",
      };
      rowElement.elements.push(packageElm);

      const noteElm: RowItemElement = {
        value: x.note || "",
        name: "note",
        width: "5.1cm",
        textAlign: "flex-end",
      };
      rowElement.elements.push(noteElm);

      rowElementProps.rows.push(rowElement);
    });

    return rowElementProps;
  }, [deliveryNoteDetail]);

  const elements = useMemo(() => {
    return [...dateElements, ...deliveryNoteElements];
  }, [dateElements, deliveryNoteElements]);
  return (
    <PreviewPrinting
      open={openPrint2Preview}
      elements={elements}
      templateImage={DeliveryNote2}
      fontSize="13px"
      paperSize={{
        height: "29.7cm",
        width: "21cm",
      }}
      backgroundSize="100% 50%"
      backgroundPosition="top"
      rowsElement={deliveryNoteItemElements}
      printIncludeTemplate={true}
      onClose={onCloseHandler}
      paperPadding="0.3cm"
    />
  );
});
